import React from 'react';

import { Button, Modal, Typography } from 'antd';

interface IProps {
  title?: string;
  buttonOk?: string;
  buttonOkColor?: string;
  buttonCancel?: string;
  open: boolean;
  onClose: () => void;
  onOk: () => void;
  loading?: boolean;
  loadingColor?: string;
  buttonOkDisabled?: boolean;
  maskClosable?: boolean;
  children?: React.ReactNode;
}

const ModalActions: React.FC<IProps> = ({
  title,
  buttonOk,
  buttonOkColor,
  buttonCancel,
  open,
  onClose,
  onOk,
  loading,
  buttonOkDisabled,
  maskClosable = true,
  children
}) => {
  return (
    <Modal
      open={open}
      title={title ?? 'Deseja realmente executar esta ação?'}
      onCancel={onClose}
      width={530}
      height={440}
      maskClosable={maskClosable}
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button type='text' onClick={onClose} disabled={loading}>
            {buttonCancel || 'Cancelar'}
          </Button>
          <Button
            type='primary'
            onClick={onOk}
            danger={buttonOkColor != null}
            disabled={loading || buttonOkDisabled}
            loading={loading}
            id='modal-button-confirm'
          >
            {buttonOk || 'Ok'}
          </Button>
        </div>
      }
      destroyOnHidden={true}
    >
      <Typography.Paragraph type='secondary' className='mb-0'>
        {children}
      </Typography.Paragraph>
    </Modal>
  );
};

export default ModalActions;
